// Keep in sync with backend/models.py's UOM_OPTIONS.
export const UOM_OPTIONS = [
  { value: "each", label: "Each" },
  { value: "box", label: "Box" },
  { value: "bag", label: "Bag" },
  { value: "pallet", label: "Pallet" },
  { value: "linear_ft", label: "Linear ft" },
  { value: "sq_ft", label: "Sq ft" },
  { value: "cubic_yd", label: "Cubic yd" },
  { value: "ton", label: "Ton" },
  { value: "bundle", label: "Bundle" },
  { value: "roll", label: "Roll" },
  { value: "gallon", label: "Gallon" },
  { value: "hour", label: "Hour" },
  { value: "lot", label: "Lot" },
];

export const uomLabel = (v) => UOM_OPTIONS.find((u) => u.value === v)?.label || v;
